import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./WindplusDetail.css";

export default function WindplusDetail() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Windplus
        </h1>

        <p className="project-description">
          Crafted a responsive and user-centric website for Windplus, transforming their digital presence with a clean interface, intuitive navigation, and strategic content structure. The website highlights their renewable energy projects while providing stakeholders with a clear understanding of their services and industry expertise.
        </p>

        <div className="project-tags">
          <span className="info-tag">Website Design</span>
          <span className="info-tag">Brochure Design</span>
          <span className="info-tag">Visiting Card Design</span>
          <span className="info-tag">Letterhead Design</span>
          <span className="info-tag">Brand Communication</span>
        </div>
      </section>

      <div className="project-full-image-section">
        <img
          src="https://ascentbw.com/Images/Windplus/Full.webp"
          alt="Windplus Energy Farm"
        />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Designed and developed a modern corporate website for Windplus, creating a seamless digital experience that showcases their renewable energy expertise, project portfolio, and end-to-end solutions across wind and solar energy sectors."
        </div>
      </section>

      <div className="project-full-image-section">
        <img
          src="https://ascentbw.com/Images/Windplus/Full1.webp"
          alt="Solar Panels Hybrid Installation"
        />
      </div>
       <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "To strengthen Windplus' corporate identity, we created a unified suite of brand communication materials, including brochures, visiting cards, and letterheads. By combining strategic content presentation, professional design, and consistent branding, these assets help communicate the company's expertise in renewable energy solutions while ensuring a polished and credible presence across all business touchpoints."
        </div>
      </section>
      <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/Windplus/Half1.webp" alt="Kelsun Lab Worker" />
        <img src="https://ascentbw.com/Images/Windplus/Half2.webp" alt="Keel Labs Materials" />
      </section>
      <div className="project-full-image-section">
        <img
          src="https://ascentbw.com/Images/Windplus/Full2.webp"
          alt="Solar Panels Hybrid Installation"
        />
      </div>
     


      <RelatedWorks excludePath="/works/windplus" />
      <Footer />
    </div>
  );
}
